import { Component, inject } from '@angular/core';
import {
  NotificationsState,
  TargetedSubscribers,
} from '@app/features/notifications/states/notifications.state';
import { Store } from '@ngxs/store';
import { Observable } from 'rxjs';

@Component({
  selector: 'rk-notification-targeted-subscribers',
  templateUrl: './notification-targeted-subscribers.component.html',
  styleUrl: './notification-targeted-subscribers.component.scss',
  standalone: false,
})
export class NotificationTargetedSubscribersComponent {
  targetedSubscribers$: Observable<TargetedSubscribers> = inject(Store).select(
    NotificationsState.targetedSubscribers,
  );
}
